const getters = {
  getActionPlanHeader(state) {
    return state.actionPlanHeader;
  },
};

export default getters;
